import { datadogRum } from '@datadog/browser-rum';
import { ENV, isLocal, VERSION } from '../shared/util/config';

// feature toggles
const IS_ENABLED_KEY = 'sfpa.analytics.public.rum.is_enabled';
const SAMPLING_RATE_KEY = 'sfpa.analytics.public.rum.sampling_rate';

const initializeDataDog = function () {
  /* toggles for analytics comes from window.chewyConf.analyticsToggles - this whole file should be deprecated
   * and moved to storefront somewhere. This is not an analytics platform technology.
   */
  const toggles = window?.chewyConf?.analyticsToggles || [];

  const clientToken = 'pub48df3fda106a4027be82b8d84a9dc5cd';
  const applicationId = '3a92cdf5-681f-46b8-9944-b1e7e366f336';

  // fetch isEnabled for current environment from Athena (fallback to Optimizely)
  const dataDogRumEnabled =
    toggles[IS_ENABLED_KEY] || window?.chewy?.abTestingClient?.isFeatureEnabled(`sfw_rum`, {});
  if (dataDogRumEnabled) {
    let sampling_percent =
      toggles[SAMPLING_RATE_KEY] ||
      window?.chewy?.abTestingClient?.getFeatureVariableInteger('sfw_rum', 'sampling_percent', {});

    sampling_percent = Number.parseFloat(sampling_percent);

    if (sampling_percent && !isLocal) {
      datadogRum.init({
        applicationId,
        clientToken,
        env: ENV,
        service: 'chewy-petprofile-ui',
        sampleRate: sampling_percent,
        datacenter: 'us',
        allowedTracingOrigins: [
          'https://www.chewy.com',
          /^https:\/\/.*\.chewy\.com$/,
          /^https:\/\/.*\.chewy\.net$/,
        ],
        version: VERSION,
        trackInteractions: true,
      });
    }
  }
};

// Singleton pattern to make sure we are only initializing datadog once
const getDatadogRum = (function () {
  let executed = false;
  return function () {
    if (!executed) {
      executed = true;
      initializeDataDog();
    }
    return datadogRum;
  };
})();

export default getDatadogRum;
